module.exports = __webpack_public_path__ + "img/pnl-2.986033b4.jpg";